import React from 'react';

const Home: React.FC = () => null;
export default Home;
